<script setup lang="ts">
const emit = defineEmits(["error"]);
</script>
<template>
  <div class="ImpactError">
    <div class="ImpactError__icon"></div>
    <div class="ImpactError__action">
      <p class="ImpactError__message">Error when trying to retrieve data.</p>
      <button class="ImpactError__retry" @click="emit('error')">Retry</button>
    </div>
  </div>
</template>
<style lang="scss">
.ImpactError {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;

  &__icon {
    width: 24px;
    height: 24px;
    margin: 3px 0;

    &:before {
      content: "\e969";
      font-family: $fontIcon;
      color: $red50;
      font-size: 24px;
      animation: rotate 2s linear infinite backwards;
    }
  }

  &__action {
    display: inline;
  }

  &__message {
    @include f-16-300;
    color: $textPrimary;
    margin-right: 4px;
    display: inline;
  }

  &__retry {
    @include f-16-500;
    color: var(--maincolor50);
  }
}
</style>
